import { hotelCancellationState } from '@voll-intelligence/domain';
import type { VoucherDocumentView } from './views/voucher_document_view.js';
import type { DocumentContext } from './context.js';
import { calendarDateFromUtcDay, dayLabel } from './dates.js';
import { money } from './format.js';
import type { Voucher } from './services.js';

/** As regras da estadia com LASTRO: até quando cancelar sem custo (a leitura
 *  única de `hotelCancellationState` — o grátis acaba quando a multa COMEÇA, a
 *  mesma data do modal de cancelamento e do voucher legado) e, quando a fonte a
 *  manda, a MULTA. `value: 0` acontece nos dados reais e não afirma multa
 *  nenhuma — só um valor positivo vira linha; sem ele fica a nota genérica da
 *  primeira diária. O documento é estático: não depende de "hoje". */
export function hotelRules(
  voucher: Voucher,
  hotel: Extract<NonNullable<Voucher['details']>, { kind: 'HOTEL' }>,
  ctx: DocumentContext,
): VoucherDocumentView['rules'] {
  const state = hotelCancellationState(hotel.cancellationPolicy, new Date());
  const until = calendarDateFromUtcDay(state?.freeUntil ?? null);
  if (!until) return null;
  const penalty = money(state?.penalty ?? null, voucher.currency);
  return {
    title: ctx.t('trips.voucher.stayRules'),
    rows: [
      {
        label: ctx.t('trips.voucher.cancellation'),
        value: ctx.t('trips.voucher.freeUntil', { day: dayLabel(until, ctx.locale) }),
      },
      ...(penalty ? [{ label: ctx.t('trips.voucher.penaltyAfter'), value: penalty }] : []),
    ],
    // Com a multa dita em número, a nota da "primeira diária" viraria uma
    // segunda afirmação sobre o mesmo custo — as duas juntas podem divergir.
    ...(penalty ? {} : { notes: [ctx.t('trips.voucher.afterFreeCancellation')] }),
  };
}
